(()=>{'use strict';const dialog=document.getElementById('bf26-offer-dialog');let opener;document.addEventListener('click',e=>{const open=e.target.closest('[data-bf26-open-terms]');if(open&&dialog?.showModal){e.preventDefault();opener=open;if(!dialog.open)dialog.showModal();}if(e.target.closest('[data-bf26-close]'))dialog?.close();if(e.target===dialog)dialog.close();});dialog?.addEventListener('close',()=>opener?.focus());const page=document.querySelector('[data-product-page]');const offer=page?.querySelector('[data-bf26-product]');if(!offer||offer.dataset.bf26Currency!=='USD')return;let variants;try{variants=JSON.parse(page.dataset.variantJson||'[]');}catch{return;}const update=()=>{const id=page.querySelector('[data-variant-id]')?.value;const variant=variants.find(v=>String(v.id)===String(id));if(!variant)return;const p=Number(variant.price),discount=p>=150000?40000:p>=90000?20000:p>=50000?10000:p>=30000?5000:0;offer.querySelector('[data-bf26-offer-price]').hidden=!discount;const saving=offer.querySelector('[data-bf26-offer-saving]');if(saving)saving.textContent=discount?'Save $'+(discount/100)+' · Automatically applied at checkout':'Save $50–$400 on qualifying footwear. Applied at checkout.';offer.querySelector('[data-bf26-offer-amount]').textContent=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format((p-discount)/100);};page.addEventListener('change',()=>requestAnimationFrame(update));const price=page.querySelector('[data-product-price]');if(price)new MutationObserver(update).observe(price,{childList:true,characterData:true,subtree:true});})();
/* Refresh Liquid-rendered footwear progress after the native drawer updates. */
(() => {
  'use strict';
  const drawer = document.querySelector('[data-cart-drawer]');
  const target = drawer?.querySelector('[data-bf26-drawer-status]');
  const items = drawer?.querySelector('[data-cart-drawer-items]');
  if (!target || !items) return;
  let controller, timer, revision = 0;
  const refresh = async () => {
    const requestRevision = ++revision;
    controller?.abort();
    controller = new AbortController();
    target.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(target.dataset.bf26CartUrl, {
        credentials: 'same-origin', cache: 'no-store', signal: controller.signal,
        headers: { Accept: 'text/html' }
      });
      if (!response.ok) throw new Error('Cart savings unavailable');
      const html = await response.text();
      const content = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-bf26-cart-content]');
      if (!content) throw new Error('Cart savings not rendered');
      if (requestRevision === revision) target.replaceChildren(content);
    } catch (error) {
      if (error.name !== 'AbortError' && requestRevision === revision) {
        const message = document.createElement('p');
        message.className = 'bf26-fine';
        message.textContent = 'Refresh your bag to see current Black Friday savings. ';
        const link = document.createElement('a');
        link.href = target.dataset.bf26CartUrl.split('?')[0];
        link.textContent = 'View bag';
        message.append(link);
        target.replaceChildren(message);
      }
    } finally {
      if (requestRevision === revision) target.removeAttribute('aria-busy');
    }
  };
  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(refresh, 60);
  };
  new MutationObserver(schedule).observe(items, { childList: true, subtree: true });
  new MutationObserver(() => {
    if (drawer.getAttribute('aria-hidden') === 'false') schedule();
  }).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
})();
